import { api } from './api';

type Target = 'landing' | 'waiting' | 'rehearse';

/**
 * Open a new browser tab impersonating a speaker, isolated from the admin's
 * normal session via sessionStorage. See lib/auth.tsx for how the preview
 * session is scoped per tab.
 */
export async function openSpeakerPreview(
  speakerId: string,
  options: { eventId?: string; target?: Target } = {},
): Promise<void> {
  const res = await api<{
    token: string;
    email: string;
    speakerId: string;
  }>(`/api/speakers/${speakerId}/preview-session`, { method: 'POST' });

  const url = new URL('/preview', window.location.origin);
  url.searchParams.set('token', res.token);
  url.searchParams.set('email', res.email);
  if (options.eventId) url.searchParams.set('eventId', options.eventId);
  if (options.target) url.searchParams.set('target', options.target);

  const win = window.open(url.toString(), '_blank', 'noopener,noreferrer');
  if (!win) {
    // Popup blocker — fall back to same-tab nav. The admin's session won't
    // be touched because PreviewLandingScene stores in sessionStorage of
    // *that* navigation context, which is still the same tab. We warn so
    // they can right-click → Open in new tab next time.
    throw new Error(
      'Could not open a new tab — your browser blocked the popup. Allow popups for this site and try again.',
    );
  }
}
